import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';

export const FIELDS_NAME = {
  EMAIL: 'email',
} as const;

export const initialValues = {
  [FIELDS_NAME.EMAIL]: '',
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.EMAIL]: Yup.string()
    .email(VALIDATIONS_ERROR.EMAIL)
    .required(VALIDATIONS_ERROR.REQUIRED),
});
